import { getOrgLkSettings } from '@/api/org'
import logger from '@/utils/logger'

/**
 * Вложенные страницы сотрудников (графики, назначение услуг) доступны
 * только при orgs.scheduleEnabled = true. Иначе редирект на список сотрудников.
 */
export default async function ({ route, redirect }) {
  const orgId = route.params.orgId
  const employeesPath = `/org/${orgId}/settings/employees`

  try {
    const res = await getOrgLkSettings(orgId)
    if (res?.data?.scheduleEnabled === true) return
  } catch (error) {
    logger.error('Ошибка проверки настройки графика сотрудников:', error)
  }

  if (route.path !== employeesPath) {
    return redirect(employeesPath)
  }
}
